/*global Stripe*/
/*eslint no-undef: "error"*/

import React, { Component } from 'react';
import Card from 'material-ui-beta/Card';
import IconButton from 'material-ui-beta/IconButton';
import Divider from 'material-ui-beta/Divider';
import numeral from 'numeral';
import Button from 'material-ui-beta/Button';
import { CircularProgress } from 'material-ui-beta/Progress';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogTitle,
} from 'material-ui-beta/Dialog';
import Slide from 'material-ui-beta/transitions/Slide';

import api from '../../api/api';
import ShoppingCartItem from './ShoppingCartItem';
import StripeApi from '../../api/StripeApi';

import closeIcon from '../../img/ic_close_white_24px.svg';
import cartIcon from '../../img/ic_shopping_cart_white_36px.svg';
import './ShoppingCart.css';

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class ShoppingCart extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showBillingInfo: false,
            showThankYou: false,
            stripeCustomer: null,
            showNonMemberDialog: false
        }
    }

    cartHasItems() {
        return this.props.cart && this.props.cart.length;
    }

    showBillingInfo = () => {
        this.setState({
            showBillingInfo: true
        })
    };

    completePurchase = (customer) => {
        api.savePurchase(this.getCartTotal(), customer, this.props.user, this.props.cart).then(purchaseRef => {
            purchaseRef.on('value', snapshot => {
                console.log('purchase snapshot update', snapshot.val());
                if (this.isPurchaseComplete(snapshot.val())) {
                    this.setState({
                        showThankYou: true
                    });
                }
            });
        });
    };

    isPurchaseComplete(purchase) {
        if (purchase.charge || purchase.subscriptions) {
            if (purchase.charge && (!purchase.charge.stripe_charge && !purchase.charge.stripe_error)) {
                return false;
            }
            if (purchase.subscriptions && (this.allSubscriptionsComplete(purchase))) {
                return false;
            }
            return true;
        }
        return false;
    }

    allSubscriptionsComplete(purchase) {
        if (purchase.subscriptions) {
            let complete = true;
            for (var attribute in purchase.subscriptions) {
                if (!this.isSubscriptionComplete(purchase.subscriptions[attribute])) {
                    complete = false;
                }
            }
            return complete;
        }
        return true;
    }

    isSubscriptionComplete(subscription) {
        return subscription.stripe_subscription || subscription.stripe_error;
    }

    getCartTotal = () => {
        let total = 0;
        if (this.props.cart) {
            this.props.cart.forEach(item => {
                total += item.getTotal();
            })
        }
        return total;
    };

    getMemberSavings = () => {
        let total = 0;
        if (this.props.cart) {
            this.props.cart.forEach(item => {
                total += item.getNonMemberTotal() - item.getMemberTotal();
            })
        }
        console.log("member savings", total);
        return total;
    };

    getContent() {
        if (this.state.showThankYou) {
            return (
                <ThankYou
                    onDoneClick={this.onDoneClick} />
            )
        } else if (this.state.showBillingInfo) {
            return (
                <BillingInfo
                    {...this.props}
                    customer={this.state.stripeCustomer}
                    completePurchase={this.completePurchase}
                    getCartTotal={this.getCartTotal}
                    onBackClick={this.onBackClick} />
            )
        }
        return (
            <ShoppingCartDetails
                {...this.props}
                showBillingInfo={this.showBillingInfo}
                customer={this.state.stripeCustomer}
                getCartTotal={this.getCartTotal}
                completePurchase={this.completePurchase}
                getMemberSavings={this.getMemberSavings}
                showNonMemberDialog={this.showNonMemberDialog} />
        )
    }

    onDoneClick = () => {
        this.setState({
            showThankYou: false,
            showBillingInfo: false,
            stripeCustomer: null,
        });
        this.props.clearCart();
    };

    onBackClick = () => {
        this.setState({
            showBillingInfo: false
        });
    };

    handleClose = () => {
        this.setState({
            showNonMemberDialog: false,
        });
        this.showBillingInfo();
    };

    onGoToWebClick = () => {
        window.open("https://infusioncenter.org/membership/");
    };

    showNonMemberDialog = () => {
        this.setState({
            showNonMemberDialog: true
        });
    };

    render() {
        return (
            <div>
                <div className={"shopping-cart-container flex" + (this.props.open ? " shopping-cart-container-visible" : "")}>
                    <Card className="shopping-cart-card flex column flex1">
                        <div className="shopping-cart-card-inner-container flex flex1">
                            <div className="flex column flex1">
                                <div className="shopping-cart-card-top flex">
                                    <div className="shopping-cart-card-title oswald flex1">
                                        Shopping Cart
                                    </div>
                                    <div className="shopping-cart-close-button">
                                        <IconButton aria-label="close" onClick={this.props.onToggleCart}>
                                            <img src={closeIcon} alt="close icon" />
                                        </IconButton>
                                    </div>
                                </div>
                                <div className="flex1 flex column">
                                    {this.getContent()}
                                </div>
                            </div>
                        </div>
                    </Card>
                </div>
                <div className={"shopping-cart-handle" + (this.cartHasItems() ? " shopping-cart-container-visible" : "")} onClick={this.props.onToggleCart}>
                    <img className="shopping-cart-handle-img" src={cartIcon} alt="shopping cart icon" />
                </div>
                <Dialog
                    open={this.state.showNonMemberDialog}
                    transition={Transition}
                    onClose={this.handleClose}>
                    <DialogTitle id="alert-dialog-slide-title">
                        <div className="flex1 oswald admin-member-resource-dialog-title">
                            Member Pricing
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <div>
                            You could save on all of the items in your cart by becoming a NICA Provider Member! Membership is $250 annually per office with a $2,500 cap.
                        </div>
                        <div className="marginTop15">
                            To become a Member today, please visit our website.
                        </div>
                        <div className="marginTop20 flex center">
                            <Button variant="raised" color="primary" className="admin-member-resource-website-button" onClick={this.onGoToWebClick}>Go to Website</Button>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">OK</Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }

}

class ShoppingCartDetails extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false
        }
    }

    cartHasItems() {
        return this.props.cart && this.props.cart.length;
    }

    onCheckoutClick = () => {
        // StripeApi.findCustomerByEmail(this.props.user.email).then(customers => {
        //     if (customers && customers.length) {
        //         console.log("customer", customers[0]);
        //         this.props.completePurchase(customers[0]);
        //     } else {
        //         this.props.showBillingInfo();
        //     }
        // }).catch(err => {
        //     alert("error fetching stripe customer");
        //     console.log("error fetching stripe customer", err);
        // });

        if (!this.props.user.isPreferred) {
            this.props.showNonMemberDialog();
        } else {
            this.setState({
                loading: true
            });
            this.props.showBillingInfo();
        }
    };

    render() {
        return (
            <div className="flex column flex1">
                <div className="shopping-cart-card-items flex1">
                    {this.cartHasItems() ?
                        this.props.cart.map((cartItem, index) => {
                            return (
                                <div key={"cart-item-" + index}>
                                    <ShoppingCartItem
                                        item={cartItem}
                                        onRemoveClick={this.props.onRemoveClick.bind(null, index)} />
                                    {index < this.props.cart.length - 1 ?
                                        <Divider />
                                        :
                                        null
                                    }
                                </div>
                            )
                        })
                        :
                        null
                    }
                </div>
                <div className="shopping-cart-card-bottom-container">
                    <Divider />
                    <div className="shopping-cart-card-bottom-title oswald">
                        <div className="flex shopping-cart-card-bottom">
                            <div className="flex1 shopping-cart-card-bottom-title oswald">
                                Total
                            </div>
                            <div className="shopping-cart-card-bottom-total lato">
                                {numeral(this.props.getCartTotal() / 100.0).format('$0,0.00')}
                            </div>
                        </div>
                        {this.props.user && this.props.user.isPreferred ?
                            <div className="flex shopping-cart-total-member-savings">
                                <div className="flex1">
                                    * Total Member Savings
                                </div>
                                <div>
                                    {numeral(this.props.getMemberSavings() / 100.0).format('$0,00.00')}
                                </div>
                            </div>
                            :
                            null
                        }
                    </div>
                    <div className="shopping-cart-checkout-button-container flex centerBoth">
                        {!this.state.loading ?
                            <Button color="primary" variant="raised" className="shopping-cart-checkout-button" onClick={this.onCheckoutClick}>Checkout</Button>
                            :
                            <CircularProgress size={35} />
                        }
                    </div>
                </div>
            </div>
        );
    }

}

class BillingInfo extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            showErrorDialog: false
        };
    }

    componentDidMount() {
        this.stripe = Stripe(document.domain !== 'locator.infusioncenter.org' ? 'pk_test_7azvwWuPUmJGXpyUvsM3S469' : 'pk_live_YVOjiL3pRXzU0txntDFgrzkG');

        // Create an instance of Elements.
        var elements = this.stripe.elements();

        // Custom styling can be passed to options when creating an Element.
        // (Note that this demo uses a wider set of styles than the guide below.)
        var style = {
            base: {
                color: '#32325d',
                lineHeight: '18px',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#aab7c4'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        };

        // Create an instance of the card Element.
        this.card = elements.create('card', {style: style});

        // Add an instance of the card Element into the `card-element` <div>.
        this.card.mount('#card-element');
    }

    onSubmitClick = () => {
        this.setState({
            loading: true
        });

        this.stripe.createToken(this.card).then((result) => {
            if (result.error) {
                this.setState({
                    loading: false
                });
            } else {
                console.log("token", result.token)
                StripeApi.createCustomer(this.props.user.email, result.token.id).then(customer => {
                    console.log("created customer:", customer);
                    this.props.completePurchase(customer);
                }).catch(err => {
                    this.setState({
                        loading: false
                    });
                    console.log(err);
                    // TODO: Need a fancy alert dialog hnaw
                    alert(err);
                });
            }
        });
    };

    handleClose = () => {
        this.setState({
            showErrorDialog: false
        });
    };

    render() {
        return (
            <div className="flex1 flex column billing-info-container">
                <div className="lato billing-info-title">
                    Enter Payment Info
                </div>
                <Card className="billing-info-card">
                    <div id="card-element" />
                </Card>
                <div className="marginTop20 flex">
                    <div className="flex1 shopping-cart-card-bottom-title oswald">
                        Total
                    </div>
                    <div className="shopping-cart-card-bottom-total lato">
                        {numeral(this.props.getCartTotal() / 100.0).format('$0,0.00')}
                    </div>
                </div>
                <div className="marginTop30 flex centerBoth">
                    {this.state.loading ?
                        <CircularProgress size={35} />
                        :
                        <div className="flex">
                            <div className="billing-info-cancel-button-container">
                                <Button color="primary" onClick={this.props.onBackClick} className="billing-info-cancel-button">Back</Button>
                            </div>
                            <Button variant="raised" color="primary" onClick={this.onSubmitClick} className="billing-info-submit-button">Submit</Button>
                        </div>
                    }
                </div>
                <Dialog
                    open={this.state.showErrorDialog}
                    transition={Transition}
                    onClose={this.handleClose}>
                    <DialogTitle id="alert-dialog-slide-title">
                        <div className="flex1 oswald admin-member-resource-dialog-title">
                            Member Pricing
                        </div>
                    </DialogTitle>
                    <DialogContent>
                        <div>
                            You could save on all of the items in your cart by becoming a NICA Provider Member! Membership is $250 annually per office with a $2,500 cap.
                        </div>
                        <div className="marginTop15">
                            To become a Member today, please visit our website.
                        </div>
                        <div className="marginTop20 flex center">
                            <Button variant="raised" color="primary" className="admin-member-resource-website-button" onClick={this.onGoToWebClick}>Go to Website</Button>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleClose} color="primary">OK</Button>
                    </DialogActions>
                </Dialog>
            </div>
        )
    }
}

class ThankYou extends Component {

    render() {
        return (
            <div className="flex1 flex column billing-info-container">
                <div className="oswald billing-info-thank-you-title">
                    Thank You!
                </div>
                <div className="lato billing-info-thank-you-description">
                    You will receive a confirmation email of your purchase.
                </div>
                <div className="marginTop30 flex centerBoth">
                    <Button variant="raised" color="primary" onClick={this.props.onDoneClick} className="billing-info-submit-button">Done</Button>
                </div>
            </div>
        );
    }

}

export default ShoppingCart;


// WEBPACK FOOTER //
// ./src/components/admin-shopping-cart/ShoppingCart.js